import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 13px;
  height: 16px;
  color: #4b4b4b;
`

const Upload = ({ title = 'Upload', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 13 16" title={title} {...rest}>
    <g id="Add-Q&amp;A" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="02.-QA_TestYourBot-Custom-Test"
        transform="translate(-497.000000, -426.000000)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <path
          d="M502.71875,426 L502.71875,431.476562 C502.71875,432.366268 503.113214,432.813068 503.947734,432.862554 L504.109375,432.867188 L509.523438,432.867188 L509.523438,439.539062 C509.523438,441.036458 508.79876,441.830702 507.383786,441.894289 L507.195312,441.898438 L499.328125,441.898438 C497.85319,441.898438 497.067057,441.17376 497.004107,439.731282 L497,439.539062 L497,428.351562 C497,426.861654 497.724677,426.067722 499.139651,426.004148 L499.328125,426 L502.71875,426 Z M503.257812,434.210938 C503.139063,434.210938 503.030312,434.250938 502.911563,434.338937 L502.820312,434.414062 L500.789062,436.289062 C500.65625,436.40625 500.59375,436.53125 500.59375,436.703125 C500.59375,437.007812 500.820312,437.226562 501.140625,437.226562 C501.253125,437.226562 501.375625,437.186562 501.476125,437.114562 L501.546875,437.054688 L502.15625,436.429688 L502.726562,435.851562 L502.671875,436.945312 L502.671875,439.382812 C502.671875,439.695312 502.9375,439.953125 503.257812,439.953125 C503.546094,439.953125 503.796406,439.744297 503.843586,439.474719 L503.851562,439.382812 L503.851562,436.945312 L503.796875,435.851562 L504.367188,436.429688 L504.976562,437.054688 C505.085938,437.164062 505.234375,437.226562 505.382812,437.226562 C505.695312,437.226562 505.929688,437.007812 505.929688,436.703125 C505.929688,436.565625 505.884687,436.453125 505.802687,436.357625 L505.734375,436.289062 L503.703125,434.414062 C503.546875,434.273438 503.414062,434.210938 503.257812,434.210938 Z M503.757812,426.070312 C504.070312,426.125 504.390625,426.351562 504.742188,426.710938 L504.742188,426.710938 L508.804688,430.84375 C509.164062,431.210938 509.390625,431.515625 509.4375,431.835938 L509.4375,431.835938 L504.164062,431.835938 C503.890625,431.835938 503.757812,431.695312 503.757812,431.421875 L503.757812,431.421875 Z"
          id="Upload"
        />
      </g>
    </g>
  </StyledIcon>
)

Upload.displayName = 'Upload'
Upload.needsWork = true
export default Upload
